/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Chart_Title_GradeInputs */

const en_ui_chart_title_grade = /** @type {(inputs: Ui_Chart_Title_GradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grade`)
};

const de_ui_chart_title_grade = /** @type {(inputs: Ui_Chart_Title_GradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steigung`)
};

/**
* | output |
* | --- |
* | "Grade" |
*
* @param {Ui_Chart_Title_GradeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_chart_title_grade = /** @type {((inputs?: Ui_Chart_Title_GradeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Chart_Title_GradeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_chart_title_grade(inputs)
	return de_ui_chart_title_grade(inputs)
});